export default "__VITE_ASSET__c$podxOJ__"